module.exports = __webpack_public_path__ + "calculator/cummins-generator-calculator/static/media/rs.04a90a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/images/products/rs.png
// module id = 823
// module chunks = 0